import React, { useState, useEffect, useReducer } from 'react'
import {
  Panel,
  Message,
  Row,
  Col,
  ControlLabel,
  Input,
  RadioGroup,
  Radio,
  SelectPicker,
  Uploader,
  Icon,
  InputGroup,
  DatePicker,
  Table,
} from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import {
  isImageOrPdf,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../utils/ValidatorUtils'
import { isEmpty } from 'lodash-es'
import {
  DATE_FORMAT,
  DATE_PICKER_FORMAT,
  DD_MM_YYYY_SLASH,
  LOCAL_DAY_TH,
} from '../../constants/date'
import { budgetFormat } from '../../utils/formatterUtil'
import notification from '../../utils/notification'
import { startLoading, doneLoading } from '../../utils/loading'
import {
  getReceivedFrom,
  downloadInstallmentIncomeAttacthment,
} from '../../redux/actions/incomeAndExpense'
import moment from 'moment'
import IncomeRecordFileTable from './IncomeRecordFileTable'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { sessionGetItemJSON, sessionGetItemStr } from '../../utils/sessionHelpers'
import ShowLimitLength from '../../components/utils/ShowLimitLength'
import PayeeModalWidget from '../payee/PayeeModalWidget'
import { getValueFromOptions, getDateThaiShort } from '../../utils/dataUtil'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'

export default function IncomeRecordForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  setIsEnableEdit = () => {},
  projectStartDate,
  projectEndDate,
  ...props
}) {
  // const { setIsEnableEdit } = props

  const triggerRef = React.useRef()
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)
  const [accChannel, setAccChannel] = useState(_schema.accountChannel.value || 0)
  const [bankAccount, setBankAccount] = useState(_schema.bankAccount.value || '')
  const [confirmAccChannel, setConfirmAccChannel] = useState(
    _schema?.accountChannelConfirm?.value || 1
  )
  const [receiveMoneyEtcVal, setReceiveMoneyEtcVal] = useState(
    _schema?.receiveMoneyEtcInfo?.name || ''
  )
  const [fileTypeError, setFileTypeError] = useState(false)

  const [period, setPeriod] = useState()
  const [totalPeriod, setTotalPeriod] = useState()
  const [showReceiveMoneyEtc, setShowReceiveMoneyEtc] = useState(false)
  const [receivedFromSchema, setReceivedFromSchema] = useState()
  const [searchNameOrId, setSearchNameOrId] = useState()
  const [fileTableData, setFileTableData] = useState([])

  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  const projectCode = sessionStorage.getItem('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')

  const defaultMaxFileSize = 5

  const styleCenter = {
    textAlign: 'center',
  }

  useEffect(() => {
    const periods = _schema?.periodOption?.options?.map((object) => {
      return object.value
    })

    if (periods) {
      setTotalPeriod(Math.max(...periods))
    }

    setPeriod(_schema?.periodOption?.value)
  }, [_schema])

  useEffect(() => {
    let periodDateEnd = moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
    let today = moment().startOf('day').toDate()

    setValue(formSchema?.accountChannel?.name, formSchema?.accountChannel?.value || '1')
    //setValue(formSchema?.attachFiles?.name, formSchema?.attachFiles?.values)
    setValue(formSchema?.bankAccount?.name, formSchema?.bankAccount?.value)
    setValue(formSchema?.accountChannelConfirm?.name, formSchema?.accountChannelConfirm?.value)
    setValue(formSchema?.bankAccountConfirm?.name, formSchema?.bankAccountConfirm?.value)
    setValue(formSchema?.description?.name, formSchema?.description?.value)
    setValue(formSchema?.receiveMoneyEtc?.name, formSchema?.receiveMoneyEtc?.value)
    setValue(formSchema?.referenceNumber?.name, formSchema?.referenceNumber?.value)
    setValue(
      formSchema?.voucherDate?.name,
      formSchema?.voucherDate?.value
        ? moment(formSchema.voucherDate.value, DD_MM_YYYY_SLASH).toDate()
        : today > periodDateEnd
          ? periodDateEnd
          : today
    )
    setValue(formSchema?.voucherNumber?.name, formSchema?.voucherNumber?.value || 'R-YY-XXXXX')

    register('deleteFileIds', [])
    if (formSchema?.attachFiles?.values && formSchema?.attachFiles?.values?.length > 0) {
      setFileTableData(formSchema?.attachFiles?.values)
    }

    if (formSchema?.accountChannelConfirm && formSchema?.isReceiveAnnuity) {
      register(
        formSchema.accountChannelConfirm?.name,
        isValidators(formSchema.accountChannelConfirm?.validators)
      )
    }
  }, [formSchema])

  const handleDeleteFileTable = (rowData) => {
    let arr = getValues('deleteFileIds') || []
    arr.push(rowData.id)
    setValue('deleteFileIds', arr)

    let _fileTable = fileTableData?.filter((item) => item.id != rowData.id)
    setFileTableData(_fileTable)
  }

  const handleSelectVender = (dataRow) => {
    setReceiveMoneyEtcVal(dataRow?.name)
    setValue(formSchema?.receiveMoneyEtc?.name, dataRow?.id)
    clearErrors(formSchema?.receiveMoneyEtc?.name)
    setShowReceiveMoneyEtc(false)
  }

  const handleCallReceivedFrom = async (nameOrId) => {
    try {
      let response = await getReceivedFrom(projectCode, nameOrId)
      if (response) {
        setReceivedFromSchema(response)
        setShowReceiveMoneyEtc(true)
        setTimeout(() => {
          forceUpdate()
        }, 500)
      } else {
        notification.open('error', {
          title: 'ไม่สำเร็จ no response',
        })
      }
    } catch (e) {
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errorMessage || 'ไม่สำเร็จ',
        })
      } else {
        notification.open('error', {
          title: 'ไม่สำเร็จ no errorMessage',
        })
      }
    }
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadInstallmentIncomeAttacthment(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadInstallmentIncomeAttacthment(fileObj.id)
      var fileName = fileObj.name

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
        header={
          periodInfo && (
            <div style={{ textAlign: 'left' }}>
              <Col lg={12} md={12} sm={24} xs={24}>
                <span>{periodInfo?.periodNo + ' (' + periodInfo?.startAndEndDate + ')'}</span>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <span>
                  {'งวดที่ ' + periodInfo?.periodNumber + '/' + periodInfo?.periodOfLength}
                </span>
              </Col>
            </div>
          )
        }
      >
        <Row style={{ marginTop: 30 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.voucherNumber.validators, formSchema.voucherNumber.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.voucherNumber.value ? (
              <b>{formSchema.voucherNumber.value}</b>
            ) : (
              <>
                <ErrorMessage error={errors[formSchema.voucherNumber.name]} />
                <Controller
                  name={formSchema.voucherNumber.name}
                  control={control}
                  defaultValue={formSchema.voucherNumber.value || 'R-YY-XXXXX'}
                  rules={isValidators(formSchema.voucherNumber.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={'ระบุ' + formSchema.voucherNumber.label}
                        value={props.value}
                        maxLength={getMaxLengthData(formSchema.voucherNumber.validators).value}
                        onChange={(value, e) => {
                          props.onChange(value)
                        }}
                        disabled={formSchema.voucherNumber.disabled}
                      />
                    )
                  }}
                />
              </>
            )}
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.referenceNumber.validators,
                formSchema.referenceNumber.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.referenceNumber.name]} />
            <Controller
              name={formSchema.referenceNumber.name}
              control={control}
              defaultValue={formSchema.referenceNumber.value || ''}
              rules={isValidators(formSchema.referenceNumber.validators)}
              render={(props) => {
                return (
                  <Input
                    placeholder={'ระบุ' + formSchema.referenceNumber.label}
                    value={props.value}
                    maxLength={getMaxLengthData(formSchema.referenceNumber.validators).value}
                    onChange={(value, e) => {
                      props.onChange(value)
                    }}
                    disabled={formSchema.referenceNumber.disabled || formSchema.isReceiveAnnuity}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.accountChannel.validators, formSchema.accountChannel.label)}
            </ControlLabel>
          </Col>

          {/* {!formSchema.isReceiveAnnuity ? ( */}
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.accountChannel.name]} />
            <Controller
              name={formSchema.accountChannel.name}
              control={control}
              defaultValue={formSchema.accountChannel.value || '1'}
              rule={isValidators(formSchema.accountChannel.validators)}
              render={(props) => {
                return (
                  <RadioGroup
                    inline
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                      setAccChannel(value)
                    }}
                  >
                    {formSchema.accountChannel.options.map((item) => (
                      <Radio
                        key={item.value}
                        value={item.value}
                        disabled={formSchema.accountChannel.disabled || formSchema.isReceiveAnnuity}
                      >
                        {item.label}
                      </Radio>
                    ))}
                  </RadioGroup>
                )
              }}
            />
          </Col>
          {/* ) : formSchema.accountChannel.value == 2 ? (
            <Col lg={8} md={8} sm={24} xs={24}>
              <p>
                {` : ${getValueFromOptions(
                  formSchema.accountChannel.options,
                  formSchema.accountChannel.value || '0'
                )}
                  `}
              </p>
              <p>
                {`${getValueFromOptions(
                  formSchema.bankAccount.options,
                  formSchema.bankAccount.value
                )}`}
              </p>
            </Col>
          ) : (
            <Col lg={8} md={8} sm={24} xs={24}>
              <p>
                {` : ${getValueFromOptions(
                  formSchema.accountChannel.options,
                  formSchema.accountChannel.value || '0'
                )}`}
              </p>
            </Col>
          )} */}

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.voucherDate.validators, formSchema.voucherDate.label)}
            </ControlLabel>
            <br />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.voucherDate.name]} />
            <Controller
              key={formSchema.voucherDate.name}
              name={formSchema.voucherDate.name}
              control={control}
              defaultValue={
                formSchema.voucherDate.value
                  ? moment(formSchema.voucherDate.value, DD_MM_YYYY_SLASH).toDate()
                  : new Date() > moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
                    ? moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
                    : new Date()
              }
              rules={isValidators(formSchema.voucherDate.validators)}
              render={(props) => {
                return (
                  <DatePickerCustom
                    {...props}
                    disabled={formSchema.isReceiveAnnuity}
                    startDate={periodInfo?.periodDateStart}
                    // endDate={periodInfo?.periodDateEnd}
                    endDate={moment.min(moment(), moment(periodInfo?.periodDateEnd))}
                    //startDate={sessionGetItemStr('projectStartDate')}
                    //endDate={sessionGetItemStr('projectEndDate')}
                  />
                )
              }}
            />
          </Col>
        </Row>
        {accChannel == '2' && formSchema?.bankAccount && (
          <>
            <Row>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(formSchema.bankAccount.validators, formSchema.bankAccount.label)}
                </ControlLabel>
              </Col>
              <Col lg={20} md={20} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.bankAccount.name]} />
                <Controller
                  name={formSchema.bankAccount.name}
                  control={control}
                  defaultValue={formSchema.bankAccount.value}
                  rules={isValidators(formSchema.bankAccount.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        style={{ minWidth: '40%' }}
                        virtualized={false}
                        searchable={true}
                        data={formSchema.bankAccount.options}
                        value={props.value}
                        menuAutoWidth
                        placeholder={'เลือก' + formSchema.bankAccount.label}
                        disabled={formSchema.bankAccount.disabled || formSchema.isReceiveAnnuity}
                        onChange={(value) => {
                          props.onChange(value)
                          setBankAccount(value)
                          // setAccChannel(value)
                          // setIsEnableEdit(value != confirmAccChannel)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
          </>
        )}

        {formSchema.isReceiveAnnuity && (
          <>
            <Row style={{ marginTop: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(
                    formSchema.accountChannelConfirm.validators,
                    formSchema.accountChannelConfirm.label
                  )}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.accountChannelConfirm.name]} />
                <Controller
                  name={formSchema.accountChannelConfirm.name}
                  control={control}
                  defaultValue={formSchema.accountChannelConfirm.value}
                  //rule={isValidators(formSchema.accountChannelConfirm.validators)}
                  render={(props) => {
                    return (
                      <RadioGroup
                        inline
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                          setConfirmAccChannel(value)
                          setIsEnableEdit(value != accChannel)
                        }}
                      >
                        {formSchema.accountChannelConfirm.options.map((item) => (
                          <Radio key={item.value} value={item.value}>
                            {item.label}
                          </Radio>
                        ))}
                      </RadioGroup>
                    )
                  }}
                />
              </Col>
            </Row>
          </>
        )}

        {confirmAccChannel == '2' && (
          <>
            <Row>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(
                    formSchema.bankAccountConfirm.validators,
                    formSchema.bankAccountConfirm.label
                  )}
                </ControlLabel>
              </Col>
              <Col lg={20} md={20} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.bankAccountConfirm.name]} />
                <Controller
                  name={formSchema.bankAccountConfirm.name}
                  control={control}
                  defaultValue={formSchema.bankAccountConfirm.value}
                  rules={isValidators(formSchema.bankAccountConfirm.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        style={{ minWidth: '40%' }}
                        virtualized={false}
                        searchable={true}
                        data={formSchema.bankAccountConfirm.options}
                        value={props.value}
                        menuAutoWidth
                        placeholder={'เลือก' + formSchema.bankAccount.label}
                        disabled={formSchema.bankAccountConfirm.disabled}
                        onChange={(value) => {
                          props.onChange(value)
                          //setConfirmAccChannel(value)
                          if (confirmAccChannel == accChannel) {
                            setIsEnableEdit(value != bankAccount)
                          } else {
                            setIsEnableEdit(true)
                          }
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
          </>
        )}

        <Row style={{ marginTop: 5 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.receiveMoneyEtc.validators,
                formSchema.receiveMoneyEtc.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.receiveMoneyEtc.name]} />
            <Controller
              name={formSchema.receiveMoneyEtc.name}
              control={control}
              defaultValue={receiveMoneyEtcVal}
              value={receiveMoneyEtcVal}
              rules={isValidators(formSchema.receiveMoneyEtc.validators)}
              render={(props) => {
                return (
                  <InputGroup>
                    <Input
                      disabled
                      value={receiveMoneyEtcVal}
                      placeholder={'ระบุ' + formSchema.receiveMoneyEtc.label}
                      onChange={(value, e) => {
                        props.onChange(value)
                      }}
                    />
                    <InputGroup.Button
                      style={{ color: '#fff', backgroundColor: '#2ba888' }}
                      onClick={() => {
                        if (formSchema.isReceiveAnnuity) {
                          return
                        }
                        handleCallReceivedFrom(null)
                        setSearchNameOrId('')
                      }}
                      disabled={formSchema.isReceiveAnnuity}
                    >
                      <Icon icon="ellipsis-h" size="lg" />
                    </InputGroup.Button>
                  </InputGroup>
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 5 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.description.validators, formSchema.description.label)}
            </ControlLabel>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.description.name]} />
            <Controller
              name={formSchema.description.name}
              control={control}
              defaultValue={formSchema.description.value || ''}
              rules={isValidators(formSchema.description.validators)}
              render={(props) => {
                return (
                  <>
                    <Input
                      componentClass="textarea"
                      rows={4}
                      placeholder={'ระบุ' + formSchema.description.label}
                      value={props.value}
                      maxLength={getMaxLengthData(formSchema.description.validators).value}
                      onChange={(value, e) => {
                        props.onChange(value)
                      }}
                      disabled={formSchema.description.disabled || formSchema.isReceiveAnnuity}
                    />
                    <ShowLimitLength
                      textLength={props.value?.length || 0}
                      maxLength={getMaxLengthData(formSchema.description.validators)?.value}
                    />
                  </>
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 25 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.attachFiles.validators,
                formSchema.attachFiles.label || 'เอกสารแนบประกอบ'
              )}
            </ControlLabel>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {/* <Message
              showIcon
              type="info"
              description={`ชนิดที่รองรับ : ${
                formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
              }`}
              style={{ marginBottom: 10 }}
            /> */}
            <ErrorMessage error={errors[formSchema.attachFiles.name]} />
            {/* {fileTypeError && (
              <Message
                closable
                onClose={() => {
                  setFileTypeError(false)
                }}
                showIcon
                type="error"
                description="อัพโหลดไฟล์เป็นรูปภาพหรือ PDF เท่านั้น *** ชนิดที่รองรับ png , jpeg , jpg , pdf ***"
              />
            )} */}
            <Controller
              key={formSchema.attachFiles.name}
              name={formSchema.attachFiles.name}
              control={control}
              rules={isValidators(formSchema.attachFiles.validators)}
              defaultValue={''}
              render={(props) => {
                return (
                  <Uploader
                    accept={formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                    autoUpload={false}
                    disabled={formSchema.attachFiles.disabled || formSchema.isReceiveAnnuity}
                    fileListVisible={true}
                    listType="picture-text"
                    fileList={props.value || []}
                    multiple
                    onChange={(fileList) => {
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                      } else {
                        let file = fileList[fileList.length - 1]

                        if (
                          file.blobFile.size >
                          (formSchema?.attachFiles?.fileSize || defaultMaxFileSize) * 1024 * 1024
                        ) {
                          notification.open('error', {
                            title: `ขนาดไฟล์เกิน ${
                              formSchema.attachFiles.fileSize || defaultMaxFileSize
                            } MB`,
                            duration: 5000,
                          })
                          return
                        }

                        if (isImageOrPdf(file.blobFile.type)) {
                          props.onChange(fileList)
                          setFileTypeError(false)
                        } else {
                          setFileTypeError(true)
                          notification.open('error', {
                            title:
                              'ชนิดที่รองรับ ' + formSchema.attachFiles.fileType ||
                              '.jpg, .jpeg, .png, .pdf',
                            duration: 5000,
                          })
                        }
                      }
                    }}
                    draggable
                  >
                    <div>
                      <Icon size="2x" icon="upload2" />
                      <small className="uploder__text"></small>
                      {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                        formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
                      } , ขนาดไฟล์ไม่เกิน ${
                        formSchema.attachFiles.fileSize || defaultMaxFileSize
                      } MB`}
                    </div>
                    {/* <div style={{ lineHeight: '100px' }}>
                      <Icon size="4x" icon="upload2" />
                      <small
                        style={{
                          marginTop: '-70px',
                          display: 'block',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                      </small>
                    </div> */}
                  </Uploader>
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 25 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {fileTableData.length > 0 && (
              <IncomeRecordFileTable
                data={fileTableData}
                deleteable={!formSchema.isReceiveAnnuity}
                onPreview={onPreview}
                onDownload={onDownload}
                onDelete={(rowData) => handleDeleteFileTable(rowData)}
              />
            )}
          </Col>
        </Row>

        {formSchema.receiveAnnuity && (
          <div>
            <Table
              wordWrap
              autoHeight
              // loading={loading}
              data={formSchema.receiveAnnuity.values}
              style={{ marginTop: 10 }}
            >
              <Column width={250} minWidth={250} flexGrow={1} height={75}>
                <HeaderCell>{formSchema.receiveAnnuity.categoryOfReceived}</HeaderCell>
                <Cell dataKey="name" />
              </Column>
              <Column width={200} style={{ textAlign: 'right' }}>
                <HeaderCell>{formSchema.receiveAnnuity.amount}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return budgetFormat(rowData['budget'])
                  }}
                </Cell>
              </Column>
              <Column width={200} style={{ textAlign: 'right' }}>
                <HeaderCell>{formSchema.receiveAnnuity.vat}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return budgetFormat(rowData['vat'])
                  }}
                </Cell>
              </Column>
              <Column width={200} style={{ textAlign: 'right' }}>
                <HeaderCell>{formSchema.receiveAnnuity.withholding}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return budgetFormat(rowData['withholding'])
                  }}
                </Cell>
              </Column>
            </Table>
          </div>
        )}
      </Panel>

      {showReceiveMoneyEtc && (
        <PayeeModalWidget
          title={'ค้นหารายการ รับทุนจากแหล่งอื่น'}
          projectCode={projectCode}
          isViewMode={false}
          show={showReceiveMoneyEtc}
          onSelect={handleSelectVender}
          onClose={() => setShowReceiveMoneyEtc(false)}
        />
      )}

      {/*
      <div className="modal-container">
        <Modal
          full
          show={showReceiveMoneyEtc}
          size="lg"
          onHide={() => setShowReceiveMoneyEtc(false)}
        >
          <Modal.Header>
            <Modal.Title>เลือการรับทุนจากแหล่งอื่น</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ width: '99%' }}>
              <Row>
                <Col lg={12} md={12} sm={24} xs={24} style={{ width: '60%' }}>
                  <InputGroup style={{ width: '100%' }}>
                    <Input
                      defaultValue={searchNameOrId}
                      value={searchNameOrId}
                      placeholder={'ระบุชื่อ หรือ เลขที่ผู้เสียภาษี'}
                      onChange={(value) => setSearchNameOrId(value)}
                    />

                    <InputGroup.Button
                      style={{ color: '#fff', backgroundColor: '#2ba888' }}
                      onClick={() => handleCallReceivedFrom(searchNameOrId)}
                    >
                      <Icon icon="search" size="lg" /> ค้นหา
                    </InputGroup.Button>
                  </InputGroup>
                </Col>
                <Col lg={12} md={12} sm={24} xs={24} style={{ width: '40%' }}>
                  <CancelButton
                    onClick={() => {
                      handleCallReceivedFrom(null)
                      setSearchNameOrId('')
                    }}
                  >
                    ยกเลิก
                  </CancelButton>
                </Col>
              </Row>
              <div style={{ minHeight: 300, maxHeight: '70hv' }}>
                <List hover style={{ padding: 10 }}>
                  <List.Item key={'header_'} index={-1} style={{ backgroundColor: '#F2F1F1' }}>
                    <FlexboxGrid style={{ fontWeight: 550 }}>
                      <FlexboxGrid.Item colspan={1} style={styleCenter}>
                        ลำดับ
                      </FlexboxGrid.Item>

                      <FlexboxGrid.Item colspan={4}>
                        <div>เลขที่ผู้เสียภาษี</div>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item colspan={6}>
                        <div>ชื่อ</div>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item colspan={11}>
                        <div>ที่อยู่</div>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item colspan={2} style={styleCenter}>
                        เลือก
                      </FlexboxGrid.Item>
                    </FlexboxGrid>
                  </List.Item>

                  {receivedFromSchema?.values?.map((item, index) => (
                    <List.Item key={item['title']} index={index}>
                      <FlexboxGrid>
                        <FlexboxGrid.Item colspan={1} style={styleCenter}>
                          {index + 1}
                        </FlexboxGrid.Item>

                        <FlexboxGrid.Item colspan={4}>
                          <div>{item['taxId']}</div>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item colspan={6}>
                          <div>{item['name']}</div>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item colspan={11}>
                          <div>{item['address']}</div>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item colspan={2} style={styleCenter}>
                          <Button
                            appearance="primary"
                            size="xs"
                            onClick={() => {
                              handleSelectVender(item)
                            }}
                          >
                            เลือก
                          </Button>
                        </FlexboxGrid.Item>
                      </FlexboxGrid>
                    </List.Item>
                  ))}
                </List>
              </div>
            </div>
             <>
              <Row>
                <Col lg={12} md={12} sm={24} xs={24} style={{ width: '60%' }}>
                  <InputGroup style={{ width: '100%' }}>
                    <Input
                      defaultValue={searchNameOrId}
                      value={searchNameOrId}
                      placeholder={'ระบุชื่อ หรือ เลขที่ผู้เสียภาษี'}
                      onChange={(value) => setSearchNameOrId(value)}
                    />

                    <InputGroup.Button
                      style={{ color: '#fff', backgroundColor: '#2ba888' }}
                      onClick={() => handleCallReceivedFrom(searchNameOrId)}
                    >
                      <Icon icon="search" size="lg" /> ค้นหา
                    </InputGroup.Button>
                  </InputGroup>
                </Col>
                <Col lg={12} md={12} sm={24} xs={24} style={{ width: '40%' }}>
                  <CancelButton
                    onClick={() => {
                      handleCallReceivedFrom(null)
                      setSearchNameOrId('')
                    }}
                  >
                    ยกเลิก
                  </CancelButton>
                </Col>
              </Row>

              {receivedFromSchema?.values?.length > 0 ? (
                <div>
                  <Table
                    //autoHeight
                    height={400}
                    data={receivedFromSchema?.values || []}
                    wordWrap
                    style={{ marginTop: 10 }}
                  >
                    <Column width={150}>
                      <HeaderCell>เลขที่ผู้เสียภาษี</HeaderCell>
                      <Cell dataKey="taxId" />
                    </Column>

                    <Column minWidth={200} flexGrow={1}>
                      <HeaderCell>ชื่อ</HeaderCell>
                      <Cell dataKey="name" />
                    </Column>

                    <Column minWidth={200} flexGrow={1}>
                      <HeaderCell>ที่อยู่</HeaderCell>
                      <Cell dataKey="address" />
                    </Column>

                    <Column width={80} fixed="right">
                      <HeaderCell>เลือก</HeaderCell>
                      <Cell>
                        {(rowData) => {
                          return (
                            <>
                              <Button
                                appearance="primary"
                                size="xs"
                                onClick={() => {
                                  handleSelectVender(rowData)
                                }}
                              >
                                เลือก
                              </Button>
                            </>
                          )
                        }}
                      </Cell>
                    </Column>
                  </Table>
                </div>
              ) : (
                <>
                  <div style={{ padding: 5 }}>
                    <List bordered>
                      <List.Item>- ไม่พบข้อมูล -</List.Item>
                    </List>
                  </div>
                </>
              )}
            </> 
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowReceiveMoneyEtc(false)} appearance="subtle">
              ปิด
            </Button>
          </Modal.Footer>
        </Modal>
      </div>*/}
    </>
  )
}
